<script setup lang="ts">
const props = defineProps<{ isSubmitting: boolean; icon: string }>();
const iconClass = computed(() => props.isSubmitting ? "i-local-loading animate-spin" : props.icon);
</script>

<template>
  <button type="submit" class="btn-circle shrink-0" :disabled="isSubmitting">
    <span :class="iconClass" />
  </button>
</template>
